import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { deleteBlog } from "services/BlogService";
import { toggleArchiveBlog } from "services/BlogService";
import { getBlogBySlug } from "services/BlogService";
import { getJWT } from "services/TokenService";
import { getUserId } from "services/TokenService";

export const BlogDetails = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  const userid = getUserId();
  const token = getJWT();
  const loggedin =
    userid != undefined && userid != null && token != undefined && token != null && (userid == 1 || userid == 2)
      ? true
      : false;
  const fetchBlog = React.useCallback(async () => {
    try {
      const res = await getBlogBySlug(slug);
      if (res.data && res.data.data) {
        setBlog(res.data.data);
      } else {
        setNotFound(true);
      }
    } catch {
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    fetchBlog();
  }, [slug, fetchBlog]);

  if (loading) {
    return (
      <div className="w-90 mx-auto mt-5-vh" style={{ textAlign: "center" }}>
        <ClipLoader color="blue" className="loader" />
      </div>
    );
  }
  if (notFound || !blog) {
    return (
      <div className="w-90 mx-auto mt-5-vh text-center text-muted">
        Blog not found.
      </div>
    );
  }

  return (
    <div className="container my-5 position-relative">
      <div className="d-flex gap-2 position-absolute top-0 end-0 z-1">
        {/* Edit button if logged in */}
        {loggedin && 
        // [7, 3, 12, 1, 27].includes(userid) && 
        (
          <a
            href={`/user/blogs/edit/${blog.slug}`}
            className="btn btn-outline-primary btn-sm"
          >
            Edit
          </a>
        )}
        {/* Archive button if logged in */}
        {loggedin && [7, 3, 12, 1, 27].includes(userid) && (
          <button
            className="btn btn-outline-warning btn-sm"
            onClick={async () => {
              await toggleArchiveBlog(blog.id);
              await fetchBlog();
            }}
          >
            {blog.archived ? "Unarchive" : "Archive"}
          </button>
        )}
        {/* Delete button if logged in */}
        {loggedin && [7, 3, 12, 1, 27].includes(userid) && (
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={async () => {
              await deleteBlog(blog.id);
              window.location.href = "/user/blogs";
            }}
          >
            Delete
          </button>
        )}
      </div>
      <h1 className="text-primary mb-2">{blog.title}</h1>
      <div className="text-muted mb-2 small">
        {blog.date} {blog.metadata && <>| {blog.metadata}</>}
      </div>
      {blog.image && (
        <img
          src={blog.image}
          alt={blog.title}
          className="img-fluid rounded mb-4"
          style={{ maxHeight: 400, objectFit: "cover", width: "100%" }}
        />
      )}
      <div
        className="mt-4"
        dangerouslySetInnerHTML={{ __html: blog.content }}
      />
    </div>
  );
};

export default BlogDetails;
